import { render, staticRenderFns } from "./ContactoData.vue?vue&type=template&id=4f17ff72"
import script from "./ContactoData.vue?vue&type=script&lang=js"
export * from "./ContactoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports